import { motion } from 'motion/react';
import { GraduationCap, Users, Award } from 'lucide-react';

export function AboutPage() {
  const audience = [
    {
      icon: GraduationCap,
      title: 'Students',
      description: 'Build foundational knowledge and practical skills for edge AI careers',
    },
    {
      icon: Users,
      title: 'Professionals',
      description: 'Upskill with cutting-edge technologies and industry best practices',
    },
    {
      icon: Award,
      title: 'Researchers',
      description: 'Explore advanced topics and push the boundaries of edge intelligence',
    },
  ];

  return (
    <div className="relative min-h-screen py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-white mb-6">About EdgeAI Academy</h2>
          <p className="text-cyan-300 text-xl max-w-3xl mx-auto mb-8">
            We're pioneering the future of intelligent edge computing through
            comprehensive, hands-on education that bridges theory and practice.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-16 p-8 rounded-xl"
          style={{
            background: 'rgba(15, 35, 60, 0.6)',
            border: '1px solid rgba(0, 229, 209, 0.2)',
          }}
        >
          <h3 className="text-white mb-4">Specialization Overview</h3>
          <p className="text-cyan-200 mb-4">
            Our Advanced Edge AI & IoT Specialization offers a complete pathway
            from fundamental embedded systems to sophisticated AI deployment at
            the edge. Each course is designed to build upon the last, creating a
            comprehensive learning journey.
          </p>
          <p className="text-cyan-200">
            Through seven intensive modules, students gain expertise in firmware
            development, AI model optimization, embedded Linux, edge networking,
            robotics, hardware acceleration, and SoC design — all critical skills
            for the next generation of intelligent devices.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mb-16"
        >
          <h3 className="text-white mb-8 text-center">Who This Is For</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {audience.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 + index * 0.15 }}
                className="p-6 rounded-xl text-center"
                style={{
                  background: 'rgba(15, 35, 60, 0.5)',
                  border: '1px solid rgba(0, 229, 209, 0.2)',
                }}
              >
                <div
                  className="w-14 h-14 rounded-full bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center mx-auto mb-4"
                  style={{
                    boxShadow: '0 0 20px rgba(0, 229, 209, 0.4)',
                  }}
                >
                  <item.icon className="w-7 h-7 text-white" />
                </div>
                <h4 className="text-white mb-2">{item.title}</h4>
                <p className="text-cyan-200">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="p-8 rounded-xl"
          style={{
            background: 'rgba(15, 35, 60, 0.6)',
            border: '1px solid rgba(0, 229, 209, 0.2)',
          }}
        >
          <h3 className="text-white mb-4">Our Platform</h3>
          <p className="text-cyan-200">
          EdgeAI Academy is a customizable educational platform powered by MindEngage's infrastructure, designed to empower subject matter experts and schools to deliver engaging, industry oriented instruction. Whether you're an independent educator or an institution, our white-labeled solution adapts to your teaching style while providing world-class content and interactive tools.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
